import { render, staticRenderFns } from "./DispatchCenter.vue?vue&type=template&id=3159e3cc&scoped=true"
import script from "./DispatchCenter.vue?vue&type=script&lang=js"
export * from "./DispatchCenter.vue?vue&type=script&lang=js"
import style0 from "./DispatchCenter.vue?vue&type=style&index=0&id=3159e3cc&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3159e3cc",
  null
  
)

export default component.exports